import { render, staticRenderFns } from "./AppComponent.vue?vue&type=template&id=ba77c0b0"
import script from "./AppComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppComponent.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseContainer: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseContainer.vue').default})
